var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({staticClass:"filter",attrs:{"rounded":"","outlined":"","dense":""},on:{"keydown":function($event){_vm.$attrs.type === 'number' ? _vm.preventNonNumericalInput($event) : false}}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }